import { Injectable } from '@angular/core';
import { Router, CanActivate } from "@angular/router";

import { AuthService } from "./auth.service";

@Injectable()
export class RouteGuardService implements CanActivate {

    constructor(private router: Router, private authService: AuthService) { }

    canActivate() {

        if (!this.authService.isSessionActive) {
            console.log("Authentication required!");
            this.router.navigate(["/login"]);
            return false;
        }

        return true;
    }
}
